// HACKFIX to make build work
// See https://github.com/mbostock/internmap/issues/3
export var InternMap = Map;
export var InternSet = Set;
